import { PendingUserWithPolicy, Policy, UserWithPolicy } from "@xapp/stentor-api-client/dist/api/orgs/orgId/users/Users";
import { Overwrite } from "@xapp/stentor-api-client/dist/models/Types";
import {
    AvailableAppsSummary,
    GetOrgAccountSummaryReturn as PaymentAccountSummary,
    GetUsersAnalyticsReturn as UserSeries,
    OrgPendingUser,
    OrgUser
} from "api";
import { UploadedImagesMap } from "components/ImageUploader";
import { Organization } from "generated/graphql";

export { OrgPendingUser, UserSeries };

export type OrgID = Pick<Organization, "name" | "organizationId" | "description">;

interface OrgMap<T> {
    [organizationId: string]: T;
}

export type OrgPage = {
    organizations: Organization[];
    lastEvaluatedKey?: string;
};

export type ErrorMap = {
    [action: string]: Error;
};

export type OrgUserMap = Overwrite<
    OrgUser,
    {
        policy?: Policy;
    }
>;

export type OrgPendingUserMap = Overwrite<
    OrgPendingUser,
    {
        policy?: Policy;
    }
>;

export type OrgUploadedImagesMap = Pick<UploadedImagesMap, "orgLogo">;

export type OrgState = {
    loading?: boolean;
    loadingAccountSummary?: boolean;
    orgs: OrgID[];
    orgPages: OrgPage[];
    currentAvailableAppsSummary?: AvailableAppsSummary;
    currentOrg?: Organization;
    currentPaymentSummary?: PaymentAccountSummary;
    users: OrgMap<UserWithPolicy[]>;
    pendingUsers: OrgMap<PendingUserWithPolicy[]>;
    uploadedImages?: OrgUploadedImagesMap;
    // todo: remove
    userAnalytics: OrgMap<UserSeries>;
    errors: ErrorMap;
    error?: Error;
};
